import { Notice, NoticeType } from "@vega-core/components/Notice/Notice";
import { m } from "@vega-core/paraglide/messages";

import { useCoInvestDealReadOnly } from "../../hooks/useCoInvestDealReadOnly";

type Props = {
  className?: string;
  message?: string;
};

export function ClosedDealNotice({ className, message }: Props) {
  const { isReadOnlyDeal, isCancelledDeal } = useCoInvestDealReadOnly();

  if (!isReadOnlyDeal) {
    return null;
  }

  // Cancelled copy always wins — page-supplied messages describe the closed
  // state (e.g. the notes exemption), which doesn't apply to cancelled deals
  const content = isCancelledDeal
    ? m.coInvestments_dealCancelled_notice()
    : (message ?? m.coInvestments_dealClosed_notice());

  return (
    <div className={className}>
      <Notice
        content={content}
        dataTestId={isCancelledDeal ? "deal-cancelled" : "deal-closed"}
        expandable={false}
        type={NoticeType.DEFAULT}
      />
    </div>
  );
}
